package com.willandsons.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.willandsons.components.layouts.PageLayoutData

@InitRoute
fun initNotFoundPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Page Not Found"))
}

@Page
@Composable
fun NotFoundPage() {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        SpanText("404 - Page Not Found")
    }
}
